import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  imports: [CommonModule],
  selector: 'app-generic-card',
  standalone: true,
  styleUrls: ["generic-card.component.scss"],
  templateUrl: 'generic-card.component.html'
})
export class GenericCardComponent {
  @Input() variant: 'default' | 'elevated' = 'default';
  @Input() interactive: boolean = true; // Set to false to disable hover effects

  get cardClasses(): string {
    const classes = ['box-parent'];
    
    if (this.variant === 'elevated') {
      classes.push('elevated');
    }
    
    if (!this.interactive) {
      classes.push('static');
    }
    
    return classes.join(' ');
  }
}